import { useContext } from 'react';
import { ArrayFieldApiContext } from '../Context.js';

function useArrayFieldApi() {
  return useContext(ArrayFieldApiContext);
}

export { useArrayFieldApi };
